export enum Routes {
  dashboard = "/",
  resourceLibrary = "/resource-library",
  reports = "/reports",
  contactUs = "/contact-us",
  companyCreate = "/companies/create/info",
  profile = "/profile",

  // admin
  admin = "/admin",
  adminEmployees = "/admin/employees",
  adminDepartments = "/admin/departments",
  adminJobTypes = "/admin/jobtypes",
  adminLocations = "/admin/locations",
  adminGroups = "/admin/groups",
  adminTraining = "/admin/training",
  adminDocuments = "/admin/documents",
  adminCompanies = "/admin/companies",
  adminCompany = "/admin/company",
  adminContacts = "/admin/contacts",
  adminCompanySetupInfo = "/admin/company/info",
  adminCompanySetupGroups = "/admin/company/groups",
  adminCompanySetupEmployees = "/admin/company/employees",
  adminCompanySetupContacts = "/admin/company/contacts",

  // training create
  trainingCreateInfo = "/training/create/info",
  trainingCreateDesc = "/training/create/desc",
  trainingCreateSettings = "/training/create/settings",
  trainingCreateMedia = "/training/create/media",
  trainingCreateBuilder = "/training/create/builder"
}
